import { AdminDrive } from '@/components/admin/AdminDrive';
import { TEMPLATE_STARTER_FOLDERS } from '@/features/admin/model';

export function TemplatesPage() {
  return (
    <AdminDrive
      library="templates"
      title="Templates"
      starterFolders={TEMPLATE_STARTER_FOLDERS}
      emptyTitle="No templates yet"
    />
  );
}
